<template>
  <div class="category-box" v-loading="loading">
    <div class="category-list">
      <div v-if="type == 'image'" class="item" :class="{ active: media_category_id === -2 }" @click="changeCategory(-2)">
        系统图标
      </div>
      <div class="item" :class="{ active: media_category_id === -1 }" @click="changeCategory(-1)">
        全部
      </div>
      <div class="item" :class="{ active: media_category_id === 0 }" @click="changeCategory(0)">
        未分组
      </div>
      <div v-for="item in category" class="item" :key="item.id" :class="{ active: media_category_id == item.id }">
        <div @click="changeCategory(item.id)">{{ item.name }}</div>
        <div class="operate">
          <i @click.prevent="editCategory(item)" class="el-icon-edit"></i>
          <el-popconfirm title="确认删除?" @onConfirm="deleteCategory(item)">
            <i slot="reference" class="el-icon-delete"></i>
          </el-popconfirm>
        </div>
      </div>
    </div>
    <div class="category-add" @click="addCategory">新增分类</div>
  </div>
</template>

<script>
export default {
  props: ['lists', 'category_id', 'type'],

  data() {
    return {
      category: [],
      loading: false,
      media_category_id: -1, //-1全部 0 未分组  -2系统图标
    };
  },

  mounted() {
    this.getCategory();
  },

  methods: {
    //资源分类列表
    async getCategory() {
      this.loading = true;
      try {
        let res = await this.api.media.listCategory();
        this.category = res.data;
        this.$emit('update:lists', this.category);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //切换分类
    changeCategory(media_category_id) {
      this.media_category_id = media_category_id;
      this.$emit('update:category_id', media_category_id);
      this.$emit('success');
    },

    //新增分类
    async addCategory() {
      try {
        let res = await this.$prompt('新增分类', '分类名称', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '1-6个字符',
          inputPattern: /^[\S]{1,6}$/,
          inputErrorMessage: '长度不正确',
        });
        this.loading = true;
        await this.api.media.addCategory({ name: res.value });
        this.$message.success('新增成功');
        this.getCategory();
      } catch (e) {
        console.error(e);
      }
    },

    //编辑分类
    async editCategory(row) {
      try {
        let res = await this.$prompt('修改分类', '分类名称', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '1-6个字符',
          inputValue: row.name,
          inputPattern: /^[\S]{1,6}$/,
          inputErrorMessage: '长度不正确',
        });
        this.loading = true;
        await this.api.media.editCategory({ name: res.value, id: row.id });
        this.$message.success('修改成功');
        this.getCategory();
      } catch (e) {
        console.error(e);
      }
    },

    //删除分类
    async deleteCategory(row) {
      try {
        await this.api.media.deleteCategory({ id: row.id });
        this.$message.success('删除成功');
        this.getCategory();
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.category-list {
  width: 150px;
  box-sizing: border-box;
  padding: 10px 0 0 25px;
  border-right: 1px solid #ddd;
  max-height: 400px;
  overflow-y: auto;

  .item {
    cursor: pointer;
    line-height: 28px;
    position: relative;
    box-sizing: border-box;
    padding-right: 40px;
  }

  .item .operate {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
    font-size: 12px;
    display: none;

    i:first-child {
      margin-right: 5px;
    }

    i:hover {
      font-weight: bold;
    }
  }

  .item:hover .operate {
    display: block;
  }

  .item:hover,
  .item.active {
    color: #409eff;
  }
}

.category-add {
  width: 60px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 12px;
  margin-left: 20px;
  margin-top: 20px;
}
</style>
